// // src/services/dashboardService.js
// import axios from "axios";
// import host from "../../../global.jsx";
// import Cookies from "js-cookie";

// const accessToken = Cookies.get("accessToken");

// const api = axios.create({
//   baseURL: host,
//   headers: {
//     Authorization: `Bearer ${accessToken}`,
//   },
// });

// export const dashboardService = {
//   getAnalytics: () => api.get("/getdashboardstats"),
//   getAllOrgAdmins: () => api.get("/getAllOrgAdmins"),
//   getInterviewCounts: () => api.get("/get-dashboard-counts"),
//   getGenieHireDashboard: (params) =>
//     api.get("/geniehire/dashboard", { params }),
// };

// src/services/dashboardService.js
import axios from "axios";
import host from "../../../global.jsx"; // Adjust path if needed

// Create axios instance
const api = axios.create({
  baseURL: host,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to attach the latest token on every request
api.interceptors.request.use((config) => {
  const accessToken = sessionStorage.getItem("accessToken");
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

// Add response interceptor for consistent error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "An unexpected error occurred";
    return Promise.reject(new Error(message));
  }
);

export const dashboardService = {
  // GET: Dashboard analytics/stats
  getAnalytics: async () => {
    const response = await api.get("/getdashboardstats");
    return response.data;
  },

  // GET: All organization admins (for dashboard view)
  getAllOrgAdmins: async () => {
    const response = await api.get("/getAllOrgAdmins");
    return response.data;
  },

  // GET: Interview counts for dashboard cards
  getInterviewCounts: async () => {
    const response = await api.get("/get-dashboard-counts");
    return response.data;
  },

  // GET: GenieHire dashboard with optional query params
  getGenieHireDashboard: async (params = {}) => {
    const response = await api.get("/geniehire/dashboard", { params });
    return response.data;
  },

  // GET: Activity insights data for dashboard table
  getActivityInsights: async (params = {}) => {
    const response = await api.get("/geniehire/dashboard", { params });
    return response.data;
  },

  // GET: Account classification data
  getAccountClassification: async () => {
    const response = await api.get("/geniehire/acc_classification");
    return response.data;
  },
};

export default dashboardService;
